export enum ReferAFriendPathsEnum {
  ROOT = "refer-a-friend",
}

export enum ReferAFriendRoutesEnum {
  ROOT = "/menu/refer-a-friend",
}
